import { getAxios } from '../../../lib/projectAxios'

/**
 * @typedef {{
 *  user_id: string,
 *  user_email: string,
 *  current_displayed_user_id: number,
 *  project_id: string,
 *  parent_account_id?: string,
 *  runtime_version: string,
 *  platform_version?: string,
 *  region?: string,
 *  environment?: string
 * status: boolean
 * }} InitFeatureStoreData
 */

/**
 * Fetch feature store initialization data from the backend
 * @param {AbortSignal} signal - AbortSignal for cancelling the request
 * @returns {Promise<InitFeatureStoreData | null>}
 */
const getFeatureStoreInitData = async (signal) => {
  const axios = getAxios()
  try {
    const response = await axios('/webprojects/init-feature-store', {
      signal,
      withCredentials: true
    })

    if (response.status >= 400) {
      console.error('[FeatureStore] API failed with status', response.status)
      return null
    }

    if (response.data?.error) {
      console.error('[FeatureStore] Init error:', response.data.error)
      return null
    }

    return response.data ?? null
  } catch (error) {
    if (error.name !== 'CanceledError' && error.code !== 'ERR_CANCELLED') {
      console.error('[FeatureStore] Fetch failed:', error)
    }

    return null
  }
}

export default getFeatureStoreInitData
